import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Empty, Flex, Layout, Spin, Typography } from "antd";
import {
  checkSignPersonalDataById,
  downloadPersonalDataById,
  getPersonalData,
  getPersonalDataPdfById,
  signPersonalDataById,
} from "entities/personal-data";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ROUTES from "shared/routes";
import { AuthHeader } from "widgets/headers";
import { SingDocument, ViewDocument } from "widgets/sign-document";
import styles from "./index.module.scss";

export const SignPersonalDataPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [shouldPoll, setShouldPoll] = useState(false);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["personal-data"],
    queryFn: () => getPersonalData(),
    refetchInterval: (query) => {
      const status = query.state.data?.edo_status?.code;
      return shouldPoll && status !== "FINISHED" ? 5000 : false;
    },
  });

  useEffect(() => {
    if ((error as any)?.status === 404) {
      navigate(ROUTES.MAIN);
    }
  }, [error, navigate]);

  if (isLoading) {
    return (
      <div className={styles.wrapperLoader}>
        <Spin />
      </div>
    );
  }

  if (isError || !data) {
    return (
      <Layout>
        <AuthHeader />
        <Layout.Content
          style={{
            paddingTop: "7vh",
            paddingBottom: 64,
          }}
          className="auth-layout-content"
        >
          <div className={styles.wrapper}>
            <Typography.Title level={3}>
              {t("personal_data.title")}
            </Typography.Title>
            <Empty
              description={
                <Typography.Text>
                  {isError
                    ? (error as any)?.response?.data?.message ||
                      t("personal_data.document_load_error")
                    : t("personal_data.document_not_found")}
                </Typography.Text>
              }
            />
            <Button
              type="primary"
              block
              onClick={() => {
                queryClient.invalidateQueries({ queryKey: ["personal-data"] });
              }}
              style={{ marginTop: 16 }}
            >
              Запросить документ снова
            </Button>
            <Button
              block
              onClick={() => navigate(ROUTES.LOGIN)}
              style={{ marginTop: 16 }}
            >
              Вернутся на страницу входа
            </Button>
          </div>
        </Layout.Content>
      </Layout>
    );
  }

  return (
    <Layout>
      <AuthHeader />
      <Layout.Content
        style={{
          paddingTop: "7vh",
          paddingBottom: 64,
        }}
        className="auth-layout-content"
      >
        <Typography.Title level={3}>
          {t("personal_data.title")}
          <br />
        </Typography.Title>

        <Flex vertical gap={"medium"}>
          <SingDocument
            document={data}
            localeKey={"personal_data"}
            setShouldPoll={setShouldPoll}
            signDocumentById={signPersonalDataById}
            checkSignDocumentById={checkSignPersonalDataById}
            customRout={
              localStorage.getItem("pathname")
                ? localStorage.getItem("pathname")
                : null
            }
          />
          <ViewDocument
            documentId={data.id}
            localeKey={"personal_data"}
            getDocumentPdfById={getPersonalDataPdfById}
            downloadDocumentById={downloadPersonalDataById}
          />
        </Flex>
      </Layout.Content>
    </Layout>
  );
};
